import { CSSProperties, FC, MouseEvent, ReactNode } from 'react';
import { TbInfoCircle } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import OurDocsLink from '@/shared/components/tags/OurDocsLink';

interface LearnMoreFooterBaseProps {
    align?: CSSProperties['textAlign'];
    href?: string;
    linkText?: string;
    variant?: 'default' | 'dropdown';
}

type LearnMoreFooterProps = LearnMoreFooterBaseProps &
    ({ message: ReactNode; topic?: never } | { message?: never; topic: ReactNode });

const LearnMoreFooter: FC<LearnMoreFooterProps> = ({
    align,
    href,
    linkText,
    message,
    topic,
    variant = 'default',
}): JSX.Element => {
    const { token } = useAntDesignTheme();
    const isDropdown = variant === 'dropdown';

    const handleClick = (event: MouseEvent<HTMLDivElement>) => {
        if (isDropdown) {
            event.stopPropagation();
        }
    };

    return (
        <div
            onClick={handleClick}
            style={{
                borderTop: isDropdown ? `1px solid ${token.colorBorder}` : undefined,
                padding: isDropdown ? '0.5rem 0.75rem' : undefined,
                textAlign: align ?? (isDropdown ? 'left' : 'center'),
            }}
        >
            <small style={{ color: token.colorTextTertiary }}>
                <TbInfoCircle style={{ verticalAlign: '-0.1rem', marginRight: '0.25rem' }} />
                {message ?? <>Learn more about {topic} in</>} <OurDocsLink href={href} text={linkText} />
            </small>
        </div>
    );
};

export default LearnMoreFooter;
